




import { Component, Vue } from "vue-property-decorator";
import ConstructionTaskForm from "../components/ConstructionTaskForm.vue";
import SwitchButton from "../../../components/SwitchButton.vue";

/**
 * 社内タスクの新規作成ページ
 */
@Component({
  components: {
    SwitchButton,
    ConstructionTaskForm
  }
})
export default class ConstructionTaskNewPage extends Vue {
  goListPage() {
    this.$router.push({ name: "construction-task-list" });
  }
}
